import React, { useState, useEffect, useCallback } from "react";

const ScreenSizeChecker = ({ onScreenSizeChange }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

  const checkScreenSize = useCallback(() => {
    const smallScreen = window.innerWidth < 1200;
    setIsSmallScreen(smallScreen);
    onScreenSizeChange(smallScreen); // Truyền trạng thái lên App.js
  }, [onScreenSizeChange]);

  useEffect(() => {
    window.addEventListener("resize", checkScreenSize);
    checkScreenSize(); // Kiểm tra khi component mount

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [checkScreenSize]);

  return (
    isSmallScreen && (
      <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-70 flex justify-center items-center text-center z-50">
        <div className="bg-white text-gray-800 rounded-lg shadow-lg w-[90%] lap:w-1/2">
          <h2 className="text-xl font-semibold text-white bg-blue-500 rounded-t-lg py-3">
            Vui lòng sử dụng Laptop hoặc PC
          </h2>
          <p className="py-4 px-2">
            Ứng dụng này sử dụng tốt nhất trên nền tảng Desktop. Mọi yêu cầu vui
            lòng liên hệ hotline{" "}
            <a href="tel:081909697" className="font-sf-semibold text-blue-600 ">
              081909697
            </a>{" "}
            hoặc email{" "}
            <a
              href="mailto:dangky@sohuutritue.vn"
              className="font-sf-semibold text-blue-600 underline"
            >
              dangky@sohuutritue.vn
            </a>
          </p>
        </div>
      </div>
    )
  );
};

export default ScreenSizeChecker;
